<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import {
    cn,
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue
  } from '@gat-ship/vue-components'
  import { useCustomFieldsView } from '../composables/useCustomFieldsView'

  // The grouped entity-target picker shared by the routed CustomFieldsLayout
  // sidebar (its #append-select-menu slot) and the AdministrationModal panel's
  // CustomFieldsManager. Reads the view context provided by an ancestor and
  // binds the selection to `ctx.selectedTarget`.
  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()

  const ctx = useCustomFieldsView()
</script>

<template>
  <Select v-model="ctx.selectedTarget.value">
    <SelectTrigger :class="cn('w-full', props.class)">
      <SelectValue placeholder="Select target" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup v-for="g in ctx.groupedTargets.value" :key="g.group">
        <SelectLabel>{{ g.group }}</SelectLabel>
        <SelectItem
          v-for="item in g.items"
          :key="item.target"
          :value="item.target"
        >
          {{ item.label }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>
